// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_a3afc74","nextArrow":"_06fcf9a","prevArrow":"_2fad3e4","singleBanner":"_0db3004","variableWidth":"_9a0ca1d"};